import React, { useEffect, useState } from 'react';
import './FruitsAndVeg.css';
import Breadcrumb from '../../../../../components/Breadcrum';
import { Modal } from "bootstrap";

export default function FruitsAndVeg() {
  const filterOptions = [
    { id: 'all', name: 'All' },
    { id: 'apples', name: 'Apples' },
    { id: 'pears', name: 'Pears' },
    { id: 'citrus', name: 'Citrus' },
  ];

  const projects = [
    {
      id: 1,
      title: 'Red Delicious',
      category: 'apples',
      imageUrl: './assets/img/Fruits/Red-Delicious.jpg',
      description: 'Red Delicious apples are mildly sweet, crunchy, and juicy. Known for their deep red color and smooth texture. Ideal for fresh eating.',
      season: 'September to April',
      origin: 'USA, South Africa, Turkey, Chile, Poland, France, Italy'
    },
    {
      id: 6,
      title: 'Royal Gala',
      category: 'apples',
      imageUrl: './assets/img/Fruits/Royal-Gala.jpg',
      description: 'Royal Gala apples are known for their crisp texture and natural sweetness. Popular for snacks and salads.',
      season: 'August to February',
      origin: 'New Zealand, USA, Chile, Poland, France, Italy'
    },
    // {
    //   id: 7,
    //   title: 'Fuji',
    //   category: 'apples',
    //   imageUrl: './assets/img/Fruits/Fuji.jpg',
    //   description: 'Fuji apples are very sweet, dense, and extremely juicy. One of the most popular dessert apples worldwide.',
    //   season: 'October to May',
    //   origin: 'Japan,  USA, India (Kashmir)'
    // },
    {
      id: 2,
      title: 'Navel Orange',
      category: 'citrus',
      imageUrl: './assets/img/Fruits/Orange-Naval-Valencia.jpg',
      description: 'Navel oranges are sweet, seedless, and very juicy. Rich in Vitamin C and ideal for direct consumption.',
      season: 'November to June',
      origin: 'South Africa, Egypt, USA'
    },
    {
      id: 3,
      title: 'Mandrin Mini Orange',
      category: 'citrus',
      imageUrl: './assets/img/Fruits/Mandrin-Mini-Orange.jpg',
      description: 'Mandarin oranges are easy to peel, sweet, and mildly tangy. Perfect for kids and snacking.',
      season: 'October to January',
      origin: 'Egypt, South Africa, China, Turkey, Morocco'
    },
    {
      id: 4,
      title: 'Grapefruits',
      category: 'citrus',
      imageUrl: './assets/img/Fruits/Grapefruits.jpg',
      description: 'Grapefruit is a large citrus fruit with a tangy and slightly bitter flavor. High in antioxidants and Vitamin C.',
      season: 'November to April',
      origin: 'USA (Florida), South Africa, Turkey'
    },
    {
      id: 5,
      title: 'Lemon',
      category: 'citrus',
      imageUrl: './assets/img/Fruits/Lemon.jpg',
      description: 'Fresh lemons are highly acidic, rich in Vitamin C, and widely used in beverages and cooking.',
      season: 'Available year-round',
      origin: 'Turkey, South Africa, Argentina'
    },
    {
      id: 8,
      title: 'Pakham Pear',
      category: 'pears',
      imageUrl: './assets/img/Fruits/Pakham-Pear.jpg',
      description: 'Pakham pears are soft, sweet, and juicy with a greenish-yellow skin. Great for eating and desserts.',
      season: 'March to October',
      origin: 'South Africa, USA  Australia'
    },
    {
      id: 9,
      title: 'Green / Red Beauty Pear',
      category: 'pears',
      imageUrl: './assets/img/Fruits/Beauty-Pear.jpg',
      description: 'Beauty pears have a crisp bite, light sweetness, and refreshing flavor. Often used for fresh eating.',
      season: 'August to February',
      origin: 'South Africa,'
    },
    {
      id: 10,
      title: 'William Pear',
      category: 'pears',
      imageUrl: './assets/img/Fruits/William-Pear.jpg',
      description: 'William pears are juicy, sweet, and aromatic with a smooth yellow-green skin.',
      season: 'August to February',
      origin: 'South Africa'
    },
    {
      id: 11,
      title: 'Asian Pear Korea',
      category: 'pears',
      imageUrl: './assets/img/Fruits/Asian-Pear-Korea.jpg',
      description: 'Asian pears are round, crisp, and extremely juicy, with a sweet aromatic flavor. Premium quality fruit.',
      season: 'August to January',
      origin: 'South Korea, Thailand '
    }
  ];



  const [activeFilter, setActiveFilter] = useState('all');
  const [selectedProduct, setSelectedProduct] = useState(null);

  const handleFilterClick = (filter, event) => {
    event.preventDefault();
    setActiveFilter(filter);
  };

  const openModal = (product) => {
    setSelectedProduct(product);

    setTimeout(() => {
      const modal = new Modal(document.getElementById("productModal"));
      modal.show();
    }, 100);
  };

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div>
      <Breadcrumb
        title="EGYPT VALLEY GOODS"
        backgroundImage="./assets/img/contact-banner.png"
        height="40vh"
      />

      <section className="container py-5">
        <div className="row justify-content-center mb-5">
          <div className="filter-btns shadow-md rounded-pill text-center col-auto">
            {filterOptions.map((filter) => (
              <a
                key={filter.id}
                className={`filter-btn btn rounded-pill btn-outline-primary border-0 m-md-2 px-md-4 ${activeFilter === filter.id ? 'active shadow' : ''}`}
                href="#"
                onClick={(e) => handleFilterClick(filter.id, e)}
              >
                {filter.name}
              </a>
            ))}
          </div>
        </div>

        <div className="row projects g-lg-3 g-md-3 g-0">
          {projects
            .filter((project) => activeFilter === 'all' || project.category === activeFilter)
            .map((project, index) => (
              <div
                key={project.id}
                className="col-lg-4 col-md-6 col-12 project"
                style={{ animationDelay: `${index * 0.2}s`, cursor: 'pointer' }}
                onClick={() => openModal(project)}
              >
                <div className="service-work overflow-hidden card mb-lg-0 mb-3">
                  <img className="card-img-top" src={project.imageUrl} alt={project.title} />
                  <div className="card-body">
                    <h5 className="card-title light-300 text-dark">{project.title}</h5>
                  </div>
                </div>
              </div>
            ))}
        </div>
      </section>

      {/* ====================== BOOTSTRAP MODAL ====================== */}
      <div
        className="modal fade"
        id="productModal"
        tabIndex="-1"
        aria-labelledby="productModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered modal-lg">
          <div className="modal-content">

            {/* HEADER */}
            <div className="modal-header">
              <h5 className="modal-title" id="productModalLabel">
                {selectedProduct?.title}
              </h5>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
              ></button>
            </div>

            {/* BODY */}
            <div className="modal-body">
              <div className="row">

                {/* PRODUCT IMAGE */}
                <div className="col-12 text-center mb-3">
                  <img
                    src={selectedProduct?.imageUrl}
                    alt={selectedProduct?.title}
                    className="img-fluid rounded"
                  />
                </div>

                {/* PRODUCT DETAILS */}
                <div className="col-12">
                  {selectedProduct?.description && (
                    <p>
                      <strong>Description:</strong> {selectedProduct.description}
                    </p>
                  )}

                  {selectedProduct?.origin && (
                    <p>
                      <strong>Origin:</strong> {selectedProduct.origin}
                    </p>
                  )}

                  {selectedProduct?.season && (
                    <p>
                      <strong>Season:</strong> {selectedProduct.season}
                    </p>
                  )}
                </div>


              </div>
            </div>

            {/* FOOTER */}
            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-secondary"
                data-bs-dismiss="modal"
              >
                Close
              </button>
            </div>

          </div>
        </div>
      </div>

    </div>
  );
}
